<div *ngIf="!hideIfEmpty || sublocations.length > 0" style="width: 100%;">
 <label>SubLocations</label>
  <search-dropdown [items]="sublocations" [label]="'name'" [uid]="'id'" [placeholder]="_placeholder"
    (afterChange)="onChanged($event)" [(ngModel)]="sublocationId">
  </search-dropdown>
</div>